import { antecedentesApi } from "../view/antecedentes.service";
import { buildFiltersUrl, reshape_response } from "../../../../helpers/functions";

export const getAntecedentes = antecedentesApi.injectEndpoints({
  endpoints: (builder) => ({
    getAntecedentes: builder.query({
      query: ({ filter_params }) => ({
        url: buildFiltersUrl("/v1/api/antecedenteacademico/", filter_params),
        method: "GET",
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "Antecedentes",
                id,
              })),
              { type: "Antecedentes", id: "LIST" },
            ]
          : [{ type: "Antecedentes", id: "LIST" }],
      transformResponse: (response, meta, args) => {
        if (Array.isArray(response)) {
          return response?.map((el) => reshape_response(el, args.shape));
        } else {
          const resultsTransformed = response?.results?.map((el) =>
            reshape_response(el, args.shape)
          );
          return {
            results: resultsTransformed,
            count: response.count,
            next: response.next,
            previous: response.previous,
          };
        }
      },
    }),
  }),
});

export const { useGetAntecedentesQuery } = getAntecedentes;
